// extracted by mini-css-extract-plugin
export default {"retangle":"marcas_retangle__Ds6cV"};